import { MOBILE_ISSUE } from '@atlassian/jira-common-constants/src/analytics-sources.tsx';
import { useAnalyticsSource } from '@atlassian/jira-issue-context-service/src/main.tsx';

export function useIsMobile() {
	const analyticsSource = useAnalyticsSource();
	return analyticsSource === MOBILE_ISSUE;
}
